import ContactName from './ContactName';
import type { ContactItemType } from '../hooks';

type ShortContact = Pick<
  ContactItemType,
  'id' | 'email' | 'phone' | 'requires_human_input' | 'first_name' | 'last_name'
>;

type ContactInfoProps = {
  contact: ShortContact;
  className?: string;
  suffix?: React.ReactNode;
  withMessagesLink?: boolean;
  withAdditionalInfo?: boolean;
};

const ContactInfo: React.FC<ContactInfoProps> = ({
  suffix,
  contact,
  className,
  withMessagesLink,
  withAdditionalInfo = true,
}) => {
  const { id, email, phone } = contact;
  const { requires_human_input, first_name, last_name } = contact;
  const name = [first_name || '', last_name || ''].filter(Boolean).join(' ');

  const nameElement = (
    <ContactName
      id={id}
      name={name}
      suffix={suffix}
      className={className}
      withMessagesLink={withMessagesLink}
      requires_human_input={requires_human_input}
    />
  );

  if (!withAdditionalInfo) return nameElement;

  return (
    <div>
      {nameElement}
      <div className="text-tiny text-textLight">{email}</div>
      <div className="text-tiny text-textLight">{phone}</div>
    </div>
  );
};

export default ContactInfo;
